module.exports = __webpack_public_path__ + "img/logo.9aa8f32c.png";